import {BaseView} from "../core/view";
import { LikeUtil } from "../utils/like-util";
import Awesomplete from "awesomplete";
import { ApiUtil } from "../utils/api-util";
import constants from "./constants";
import { KeyboardUtil } from "../utils/keyboard-util";
import { LinkUtil } from "../utils/link";
import SideNavigationView from "./side-view";
import { SelectorUtil } from "../utils/selector-util";
import { UrlUtil } from "../utils/url-util";
import { MobileUtil } from "../utils/mobile";
import { TrackingUtil } from "../utils/tracking";

let blur = true;

export default BaseView.extend({

    el: '.js-navigation',

    events: {
        'click .js-hamburger': 'toggleSideBarDebounced',
        'click .js-navigation-search-open': 'openSearch',
        'click .js-navigation-search-close': 'closeSearch',
        'click .js-navigation-search-clear': 'clearSearch',
        'mousedown .js-navigation-search-clear': 'invalidateBlur',
        'keyup .js-navigation-search-input': 'updateAutocompleteList',
        'paste .js-navigation-search-input': 'updateAutocompleteList',
        'focus .js-navigation-search-input': 'enteredInputField',
        'blur .js-navigation-search-input': 'blurInput',
        'mousedown .js-navigation-search-input': 'openSearch',
        'submit .js-navigation-search': 'formSubmit'
    },

    cssClasses: {
        searchOpen: 'navigation--search-open',
        searchClosing: 'navigation--search-closing',
        sideNavOpen: 'navigation--menu-open',
        outerSideNavVisible: 'side-navigation--visible',
        outerSideNavOpen: 'side-navigation--open',
        bodySearchOpen: 'is-navigation-search-open',
        bodyMenuOpen: 'is-navigation-menu-open',
        activeNavItem: 'navigation__verticals__item--active',
        categoriesVisible: 'navigation__categories--visible',
        showImageNavItem: 'navigation__verticals__item--show-image',
        formGroupVisible: 'navigation__search__form-group--visible',
        formGroupOpen: 'navigation__search__form-group--open',
        isTyping: 'navigation--is-typing',
        loadedNavigation: 'navigation--loaded'
    },

    initialize: function(){
        if(!this.el) return;

        this.elements = {
            searchFormGroup1st: this.el.querySelector('.js-navigation-first-row .js-search-form-group'),
            searchFormGroup2nd: this.el.querySelector('.js-navigation-second-row .js-search-form-group'),
            searchForm: this.el.querySelector('.js-navigation-second-row .js-search-form'),
            outerSideNav: document.querySelector('.js-side-navigation'),
            allNavigationVerticals: this.el.querySelectorAll('.js-navigation-vertical')
        };

        this.initializeSideBar();

        this.countUserLikes();

        const activeElement = this.el.querySelector(`.${this.cssClasses.activeNavItem}`);
        if(activeElement){
            this.activeVertical = this.getVertical(activeElement);
        } else {
            this.activeVertical = "neutral";
        }

        const activeVerticalElement = this.el.querySelector(`[data-vertical='${this.activeVertical}']`);

        this.loadVerticalSubCategories(activeVerticalElement || "women");

        if(MobileUtil.isApp()){
            this.openSearch(this.elements.searchFormGroup1st);
        }

        this.el.classList.add(this.cssClasses.loadedNavigation);

        if(this.sideBar.el){
            TrackingUtil.throwGAEvent('Navigation', 'visible', 'Hamburger', true);
        }
    },

    getVertical: function(element){
        return element.getAttribute('data-vertical');
    },

    formSubmit: function(event){
        const currentForm = event.currentTarget;
        const input = currentForm.querySelector('.js-navigation-search-input');
        input.value = input.value.trim();
        if(!input.value){
            event.preventDefault();
        }
    },

    focusInput: function(event){
        const input = event.currentTarget || event;
        input.focus();
    },

    enteredInputField: function(input){
        const currentValue = (input.currentTarget || input).value;

        if(currentValue.length){
            if(input.setSelectionRange) input.setSelectionRange(currentValue.length, currentValue.length);
            else{
                const currentValue = input.value;
                input.value = "";
                setTimeout(() => input.value = currentValue, 0);
            }
            setTimeout(() => {
                this.el.classList.add(this.cssClasses.isTyping);
            }, 300);
        }
        else{
            this.el.classList.remove(this.cssClasses.isTyping);
        }
    },

    blurInput: function(event){
        if(blur || !event){
            this.el.classList.remove(this.cssClasses.isTyping);
            if(this.isHOS) this.closeSearch();
        }
        else event.preventDefault();

        blur = true;
    },

    invalidateBlur: function(){
        blur = false;
    },

    countUserLikes: async function(){
        const likes = await LikeUtil.getLikes();
        if(likes.length){
            this.el.querySelector('.js-navigation-wishlist-counter').setAttribute('data-wishlist-items', likes.length);
        }
    },

    toggleSideBar: function(requestedByUser){
        const self = this;
        if(document.body.classList.contains(this.cssClasses.bodyMenuOpen) || !requestedByUser){ //closing sequence
            this.sideBar.el.classList.remove(this.cssClasses.outerSideNavOpen);
            this.el.classList.remove(this.cssClasses.sideNavOpen);
            document.body.classList.remove(this.cssClasses.bodyMenuOpen);
            setTimeout(() => {
                self.sideBar.el.classList.remove(self.cssClasses.outerSideNavVisible);
                self.sideBar.resetToActiveVertical.call(self.sideBar);
            }, 300);
            window.removeEventListener('resize', self.toggleSideBarThrottled.bind(self));
        }
        else{ //opening sequence
            this.sideBar.el.classList.add(this.cssClasses.outerSideNavVisible);
            document.body.classList.add(this.cssClasses.bodyMenuOpen);
            this.el.classList.add(this.cssClasses.sideNavOpen);
            setTimeout(() => self.sideBar.el.classList.add(self.cssClasses.outerSideNavOpen), 50);
            window.addEventListener('resize', self.toggleSideBarThrottled.bind(self));
            TrackingUtil.throwGAEvent('Navigation', 'clicked', 'Hamburger', false);
        }
    },

    toggleSideBarDebounced: _.debounce(function(requestedByUser){
        this.toggleSideBar(requestedByUser);
    }, 300),

    toggleSideBarThrottled: _.throttle(function(){
        if(MobileUtil.isDesktop()){
            this.toggleSideBar(false);
        }
    }, 300),

    initializeSideBar: _.once(function(){
        this.sideBar = new SideNavigationView();
    }),

    loadVerticalSubCategories: function(e){
        if(!e) return;

        let current = e.currentTarget || e;

        if(typeof e === "string"){
            current = this.el.querySelector(`[data-vertical='${e}']`);
            if(current) current.classList.add(this.cssClasses.showImageNavItem);
            else return;
        }
        else{
            if(!current.classList.contains(this.cssClasses.activeNavItem) || !current.classList.contains(this.cssClasses.showImageNavItem)){
                Array.prototype.forEach.call(this.elements.allNavigationVerticals, (item) => {
                    item.classList.remove(this.cssClasses.activeNavItem);
                    item.classList.remove(this.cssClasses.showImageNavItem);
                });

                current.classList.add(this.cssClasses.activeNavItem);
                current.classList.add(this.cssClasses.showImageNavItem);
            }
        }

        const vertical = this.getVertical(current);

        const activeCategories = this.el.querySelector(`.js-navigation-categories[data-origin='${vertical}']`);
        if(activeCategories && !activeCategories.classList.contains(this.cssClasses.categoriesVisible)){
            Array.prototype.forEach.call(this.el.querySelectorAll('.js-navigation-categories'), (item) => {
                item.classList.remove(this.cssClasses.categoriesVisible);
            });
            activeCategories.classList.add(this.cssClasses.categoriesVisible);
        }
    },

    openSearch: function(event){
        const target = event.currentTarget || event;
        let targetForm = SelectorUtil.closest(target, '.js-navigation-search');
        let input = target.classList.contains('js-navigation-search-input') ? target : targetForm.querySelector('.js-navigation-search-input');

        if(!this.el.classList.contains(this.cssClasses.searchOpen)){
            this.initializeAutocomplete(input);

            if(this.el.classList.contains(this.cssClasses.sideNavOpen)) this.toggleSideBar(false); //closes side bar if it's open

            this.el.classList.add(this.cssClasses.searchOpen);

            if(!MobileUtil.isDesktop()){
                document.body.classList.add(this.cssClasses.bodySearchOpen);
                this.elements.searchFormGroup1st.classList.add(this.cssClasses.formGroupVisible);
                setTimeout(() => {
                    this.elements.searchFormGroup1st.classList.add(this.cssClasses.formGroupOpen);
                }, 0);
            }

            if(!MobileUtil.isApp()) this.focusInput(input);

            TrackingUtil.throwGAEvent('Navigation', 'clicked', 'Textsearch', false);
        }
    },

    initializeAutocomplete: _.once(function(input){
        const self = this;

        this.autocomplete = new Awesomplete(input, {
            minChars: 1,
            sort: false,

            container: () => SelectorUtil.closest(input, '.js-search-form-group'),

            item: function(option, input, item_id){
                const builtItem = Awesomplete.ITEM(option, input, item_id);
                builtItem.innerHTML = input.trim() === "" ? "" : option.label.markup;
                builtItem.classList.add('navigation__search__list__item');
                return builtItem;
            },

            data: (item) => {
                return {
                    "value": item.name,
                    "label": {
                        "link": item.url,
                        "markup": item.html
                    }
                };
            },

            filter: () => true //we don't need the plugin's filter, as we already filter from the API
        });

        this.autocomplete.input.addEventListener('awesomplete-highlight', (event) => {
            self.autocomplete.replace(event.text);
        });

        this.autocomplete.input.addEventListener('awesomplete-select', (event) => {
            event.preventDefault();
            self.autocomplete.goto(Array.prototype.indexOf.call(self.autocomplete.ul.children, event.origin));
            self.autocomplete.replace(event.text);
            LinkUtil.goToUrl(UrlUtil.addParameter(event.text.label.link, "q", encodeURIComponent(event.text.value.toLowerCase()), true));
        });

        this.autocomplete.ul.classList.add('navigation__search__list');
    }),

    closeSearch: function(){
        if(!MobileUtil.isDesktop()){
            this.elements.searchFormGroup1st.classList.remove(this.cssClasses.formGroupOpen);
            setTimeout(() => {
                document.body.classList.remove(this.cssClasses.bodySearchOpen);
                this.elements.searchFormGroup1st.classList.remove(this.cssClasses.formGroupVisible);
                this.el.classList.remove(this.cssClasses.searchOpen);
            }, this.isHOS ? 0 : 300);
        }
        else{
            this.el.classList.remove(this.cssClasses.searchOpen);
        }
    },

    clearSearch: function(event){
        const input = SelectorUtil.closest(event.currentTarget, '.js-navigation-search').querySelector('.js-navigation-search-input');
        input.value = "";
        this.focusInput(input);
    },

    updateAutocompleteList: _.debounce(function(event){
        const keyCode = event.keyCode;
        const input = event.currentTarget;
        const searchText = input.value.trim();

        if(searchText.length){
            this.el.classList.add(this.cssClasses.isTyping);

            if(keyCode === KeyboardUtil.keyEnter){
                if(this.autocomplete.selected){
                    event.preventDefault();
                    return false;
                }
            }

            if(keyCode === KeyboardUtil.keyArrowDown || keyCode === KeyboardUtil.keyArrowUp) return;

            if(this.activeText !== searchText){
                const self = this;
                ApiUtil.request({
                    data: {
                        searchstring: searchText
                    },
                    path: constants.SEARCH_AUTOCOMPLETION_URL,
                    success: function (response) {
                        self.autocomplete.list = response.data;
                    }
                });

                this.activeText = searchText;
            }
        }
        else{
            this.el.classList.remove(this.cssClasses.isTyping);
        }

    }, 300)
});